import lodash from "lodash";
import i18n from "../../../../../../i18n";
import store from "../../../../../../store";
import { onClickDeleteAllClient } from "../../../../../../utils/form";

import {
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createPage
} from "../../../../../../utils/page";
import { createLoading } from "../../../../../../utils/loading";
import { createButtonCreate } from "../../../../../../utils/button";
import { createColumns } from "./send-sampling-product-info.section";
import { openModalList as openModalSamplingList } from "../../../sampling/sampling/sampling.logic";
import { onIFrameClickSelectAll } from "../../../../../../utils/iframe";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/sendSamplingProduct";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [
        createManageExtraCreate({ menuContext,
            visible: () => canCreate && [ undefined, "draft", "reEditAuthority" ].includes(modelRef.refStatus?.key) && ![ "3", "4" ].includes(modelRef.refRequestType?.key),
            render: () => createButtonCreate({
                onClick: () => {
                    openModalSamplingList({
                        onIframeMounted: ({ refs, options }) => {
                            const itemKey = "refSampling.id";
                            const rowKey = "id";
                            onIFrameClickSelectAll({
                                refs,
                                options,
                                items,
                                itemKey,
                                rowKey,
                                setKey: 'refSampling',
                                onSearch: ({ page }) => {
                                    page.where.push({name: 'refStatus.key', type: 'String', operator: '=', value: "complete"})
                                    page.where.push({name: 'isSendSampling', type: 'Boolean', operator: '=', value: false })
                                    const value = items.filter((d) => d.isDelete !== true).map((d) => lodash.get(d, itemKey));
                                    if (value.length > 0) {
                                        page.where.push({ name: rowKey, type: "UUID", operator: "!in", value });
                                    }
                                }
                            })
                        },
                    });
                },
                options: { text: i18n.global.t('button.add') },
            }),
        })
    ];

    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
}

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};